import React, { useEffect } from 'react';
import { AdProductGroup } from '@models/account';
import { useSearchParams } from 'react-router-dom';
import AdspRegistrationPage from 'src/pages/adspRegistration/page';
import RegistrationPage from 'src/pages/registration/page';
import RetailerAccountRegistrationPage from 'src/pages/retailerAccountRegistration/page';
import { fetchSauronContext } from 'src/shared/state/redux';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'src/shared/state/store';

/**
 * We have two registration views: one for SAR and one for PLD registration.
 * Checks if the /registration endpoint has the query parameter 'invitationToken' and loads the appropriate component accordingly.
 */
const RegistrationRouter = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [searchParams] = useSearchParams();
  const invitationToken = searchParams.get('invitationToken');
  const registrationProgram = searchParams.get('adProductGroup');

  useEffect(() => {
    dispatch(fetchSauronContext());
  }, [dispatch]);

  if (registrationProgram?.toUpperCase() === AdProductGroup.ADSP) {
    return <AdspRegistrationPage />;
  }

  return invitationToken ? (
    <RetailerAccountRegistrationPage invitationToken={invitationToken} />
  ) : (
    <RegistrationPage />
  );
};

export default RegistrationRouter;
